import { render } from "./InsuranceOperations.vue?vue&type=template&id=edd64830"
import script from "./InsuranceOperations.vue?vue&type=script&lang=js"
export * from "./InsuranceOperations.vue?vue&type=script&lang=js"

import "./InsuranceOperations.vue?vue&type=style&index=0&id=edd64830&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__